<template>
  <div>
    <template v-if="!production">
      <b-form-group label="Table Options" label-cols-lg="2" v-slot="{ ariaDescribedby }">
        <b-form-checkbox v-model="striped" :aria-describedby="ariaDescribedby" inline>Striped</b-form-checkbox>
        <b-form-checkbox v-model="bordered" :aria-describedby="ariaDescribedby" inline>Bordered</b-form-checkbox>
        <b-form-checkbox v-model="borderless" :aria-describedby="ariaDescribedby" inline>Borderless</b-form-checkbox>
        <b-form-checkbox v-model="outlined" :aria-describedby="ariaDescribedby" inline>Outlined</b-form-checkbox>
        <b-form-checkbox v-model="small" :aria-describedby="ariaDescribedby" inline>Small</b-form-checkbox>
        <b-form-checkbox v-model="hover" :aria-describedby="ariaDescribedby" inline>Hover</b-form-checkbox>
        <b-form-checkbox v-model="dark" :aria-describedby="ariaDescribedby" inline>Dark</b-form-checkbox>
        <b-form-checkbox v-model="fixed" :aria-describedby="ariaDescribedby" inline>Fixed</b-form-checkbox>
        <b-form-checkbox v-model="footClone" :aria-describedby="ariaDescribedby" inline>Foot Clone</b-form-checkbox>
        <b-form-checkbox v-model="noCollapse" :aria-describedby="ariaDescribedby" inline>No border collapse</b-form-checkbox>
      </b-form-group>

      <b-form-group label="Head Variant" label-cols-lg="2" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
            v-model="headVariant"
            :aria-describedby="ariaDescribedby"
            class="mt-lg-2"
        >
          <b-form-radio :value="null" inline>None</b-form-radio>
          <b-form-radio value="light" inline>Light</b-form-radio>
          <b-form-radio value="dark" inline>Dark</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group label="Table Variant" label-for="table-style-variant" label-cols-lg="2">
        <b-form-select
            id="table-style-variant"
            v-model="tableVariant"
            :options="tableVariants"
        >
          <template #first>
            <option value="">-- None --</option>
          </template>
        </b-form-select>
      </b-form-group>
    </template>
    <b-table
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :small="small"
        :hover="hover"
        :dark="dark"
        :fixed="fixed"
        :foot-clone="footClone"
        :no-border-collapse="noCollapse"
        :items="items"
        :fields="fields"
        :head-variant="headVariant"
        :table-variant="tableVariant"
        :show-empty="showEmpty"
        @row-clicked="handleRowClicked"
    >
      <template #empty="scope">
        <p>No Call Logs from your family. Click here for tutorial.</p>
      </template>
      <template #cell(notes)="row">
        <tip-tap-output
            v-if="row && row.item && row.item.note"
            :content="Array.isArray(row.item.note) ? row.item.note : []"
        />
      </template>
      <template #cell(_created_at)="row">
        {{ formatDate(row.item._created_at) }}
      </template>
    </b-table>
  </div>
</template>

<script>
import moment from 'moment';
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  components: {TipTapOutput},
  props: {
    resource: {
      type: Object,
      default: () =>{},
      required: false
    },
    items: {
      type: Array,
      default: () => [ { phone: 3106214068, name: 'Appeal Note', notes: 'Thee are my notes about the call' },],
      required: false
    },
    logDocsAll:{
      type: Array,
      default: () => [],
      required: false
    },
  },
  methods:{
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    },
    /* EMITTERS */
    handleRowClicked(item){
      this.$emit('log-row-clicked', item);
    },
    handleGoToDocViewClick(){
      this.$emit('go-to-docs-view');
    }
  },
  data() {
    return {
      production: true,
      fields: [
        {
          key: "phone",
          sortable: true,
          label: "Phone Number"
        },
        {
          key: "notes",
          sortable: true,
          label: "Notes"
        },
        {
          key: "_created_at",
          sortable: true,
          label: "Last Update"
        },
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: true,
      headVariant: null,
      tableVariant: '',
      showEmpty: true,
      noCollapse: false
    }
  }
}
</script>